module.exports = __webpack_public_path__ + "static/img/draw-box1.c3b2c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw-box1.png
// module id = mB3C
// module chunks = 0